// re.rejouis.fr — QR code Mondial Relay à présenter en point relais (le relais imprime
// l'étiquette : pas besoin d'imprimante), avec le secours « mon relais n'accepte pas le
// QR code » → étiquette PDF créée à la demande (nouvelle expédition côté lab, cf. lab
// _bordereau.js). Utilisé par la confirmation, le suivi, les retours et la page /envoi
// (partenaires, en vouvoiement : prop `vous`).
import { useState } from 'react';
import { Icons, Spinner } from './ui.jsx';
import { actionDemande } from '../lib/api.js';

const CARTE_RELAIS = 'https://www.mondialrelay.fr/trouver-le-point-relais-le-plus-proche-de-chez-moi/';

const TEXTES_TU = {
  titre: 'Ton QR code Mondial Relay',
  consigne: 'Présente-le au point relais avec ton colis : ils impriment l’étiquette pour toi. Pas besoin d’imprimante.',
  verifier: 'vérifie le tien',
  confirmer: 'Créer une étiquette à imprimer ?\n\nLe QR code ne sera alors plus valable : utilise uniquement l’étiquette imprimée.',
  erreur: 'Une erreur est survenue, réessaie dans un instant.',
  imprimer: 'Imprimer mon étiquette',
};
const TEXTES_VOUS = {
  titre: 'Votre QR code Mondial Relay',
  consigne: 'Présentez-le au point relais avec votre colis : ils impriment l’étiquette pour vous. Pas besoin d’imprimante.',
  verifier: 'vérifiez le vôtre',
  confirmer: 'Créer une étiquette à imprimer ?\n\nLe QR code ne sera alors plus valable : utilisez uniquement l’étiquette imprimée.',
  erreur: 'Une erreur est survenue, réessayez dans un instant.',
  imprimer: 'Imprimer l’étiquette',
};

// demanderEtiquettePdf (optionnel) : autre source que la demande de reprise (ex. retours
// après achat) — fonction async qui renvoie { labelUrl }.
export default function EtiquetteQr({ qrCode, refDemande, onPdf, demanderEtiquettePdf, vous = false }) {
  const t = vous ? TEXTES_VOUS : TEXTES_TU;
  const [pdf, setPdf] = useState(null);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  async function demanderPdf() {
    if (!window.confirm(t.confirmer)) return;
    setEnCours(true);
    setErreur(null);
    try {
      const res = demanderEtiquettePdf ? await demanderEtiquettePdf() : await actionDemande('etiquette_pdf', refDemande);
      setPdf(res.labelUrl || null);
      if (onPdf) await onPdf(res);
    } catch (e) {
      setErreur(e.message || t.erreur);
    } finally {
      setEnCours(false);
    }
  }

  if (pdf) {
    return (
      <a className="btn btn-primary btn-block" href={pdf} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <Icons.download size={16} /> {t.imprimer}
      </a>
    );
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontWeight: 800, fontSize: 15 }}>{t.titre}</div>
      <div style={{ fontSize: 12.5, color: 'var(--stone)', lineHeight: 1.55, margin: '4px 0 12px' }}>
        {t.consigne}
      </div>
      <img src={`/api/qr?d=${encodeURIComponent(qrCode)}`} alt="QR code à présenter en point relais" width={220} height={220}
        style={{ width: 220, height: 220, display: 'block', margin: '0 auto', background: '#fff', borderRadius: 12, border: '1px solid var(--bord)' }} />
      <div style={{ fontSize: 12, color: 'var(--stone)', marginTop: 12, lineHeight: 1.55 }}>
        Tous les relais n’acceptent pas encore le QR code&nbsp;:{' '}
        <a href={CARTE_RELAIS} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--rouge)', fontWeight: 600 }}>{t.verifier}</a>.
      </div>
      <button className="btn btn-tertiary btn-block" style={{ marginTop: 6 }} disabled={enCours} onClick={demanderPdf}>
        {enCours ? <Spinner size={16} /> : 'Mon relais n’accepte pas le QR code : étiquette à imprimer'}
      </button>
      {erreur ? <div style={{ fontSize: 12.5, color: 'var(--rouge-sombre)', marginTop: 6 }}>{erreur}</div> : null}
    </div>
  );
}
